// 关于我们详情 导航 + banner图
<template>
  <div class="aboutus-details">
    <my-nav>{{title}}</my-nav>
    <van-image class="van-img" :src="require('@/assets/images/aboutus_banner.png')" />
  </div>
</template>
<script>
export default {
  name: 'AboutBanner',
  props: ['title']
}
</script>
<style scoped lang="less">
.van-image {
  display: block;
}
</style>
<style lang="less">
.aboutus-bgColor {
  min-height: 100%;
  background-color: #ffffff;
  text-align: center;
}
.aboutus-main {
  padding: 24px 12px;
  .text-info {
    text-indent: 15px;
    font-size: 15px;
    color: #221815;
    line-height: 30px;
    text-align: left;
  }
}
</style>